"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddressServices = void 0;
const react_1 = require("react");
const hooks_1 = require("../../../hooks");
function useAddressServices({ onLoading, provinceSelected, services }) {
    const { data: provinces, call: getProvinces } = (0, hooks_1.useAsyncStateInfo)(services.getProvincesService);
    const { data: cities, call: getCities } = (0, hooks_1.useAsyncStateInfo)(services.getCitiesService);
    (0, react_1.useEffect)(() => {
        onLoading?.(true);
        getProvinces().finally(() => onLoading?.(false));
    }, [getProvinces, onLoading]);
    (0, react_1.useEffect)(() => {
        if (provinceSelected && provinces) {
            onLoading?.(true);
            const provinceCode = provinces.find(p => p.postalCode === provinceSelected)?.code;
            getCities(provinceCode).finally(() => onLoading?.(false));
        }
    }, [getCities, provinceSelected, onLoading, provinces]);
    return {
        provinces: provinces ?? [],
        cities: cities ?? [],
    };
}
exports.useAddressServices = useAddressServices;
//# sourceMappingURL=useAddressServices.js.map